export default "__VITE_ASSET__B8v81C5M__"